import { NavLink } from 'react-router-dom';

import { Container } from '@/components/common';
import { routes } from '@/config/routes';

const footerGroups = [
  {
    title: 'Shop',
    links: [
      ['All products', routes.products],
      ['Wood engraving', routes.woodEngraving],
      ['Ornaments', routes.ornaments],
      ['Custom T-shirts', routes.tshirts],
    ],
  },
  {
    title: 'Customer Care',
    links: [
      ['How it works', routes.howItWorks],
      ['FAQ', routes.faq],
      ['Contact', routes.contact],
      ['Track order', routes.orders],
    ],
  },
  {
    title: 'About Emazy',
    links: [
      ['Our purpose', routes.about],
      ['Reorders', routes.dashboard],
    ],
  },
  {
    title: 'Legal',
    links: [
      ['Privacy', routes.privacy],
      ['Terms', routes.terms],
    ],
  },
] as const;

export function PublicFooter() {
  return (
    <footer className="public-footer">
      <Container size="wide">
        <div className="public-footer__main">
          <div className="footer-newsletter">
            <NavLink className="wordmark wordmark--footer" to={routes.home}>
              <span className="wordmark__mark" aria-hidden="true">
                E
              </span>{' '}
              Emazy
            </NavLink>
            <h2>Thoughtful ideas, when the moment calls.</h2>
            <p>Newsletter updates will become available in a future milestone.</p>
            {/* Presentational only in M1; submission remains intentionally disabled. */}
            <form className="newsletter-form" aria-label="Newsletter coming soon">
              <label htmlFor="newsletter-email">Email address</label>
              <div>
                <input id="newsletter-email" type="email" placeholder="you@example.com" disabled />
                <button type="button" disabled>
                  Coming soon
                </button>
              </div>
            </form>
          </div>
          <div className="footer-links">
            {footerGroups.map((group) => (
              <nav aria-label={group.title} key={group.title}>
                <h2>{group.title}</h2>
                {group.links.map(([label, to]) => (
                  <NavLink key={to} to={to}>
                    {label}
                  </NavLink>
                ))}
              </nav>
            ))}
          </div>
        </div>
        <div className="public-footer__bottom">
          <small>© {new Date().getFullYear()} Emazy. All rights reserved.</small>
          <div aria-label="Social media placeholders">
            <button
              className="icon-button"
              type="button"
              disabled
              aria-label="Instagram coming soon"
            >
              <i className="pi pi-instagram" />
            </button>
            <button
              className="icon-button"
              type="button"
              disabled
              aria-label="Facebook coming soon"
            >
              <i className="pi pi-facebook" />
            </button>
          </div>
        </div>
      </Container>
    </footer>
  );
}
